<template>
    <div>
        <div class="popup__content">
            <div class="add-worker__top mb24">
                <div class="text-size-l text-bold text-color">Контакт <span v-if="editContact.banned">заблокирован {{editContact.dateEditGroup}}</span></div>
            </div>
            <div style=" width: 100%;">
				<div class="flex-row mb16">
                    <div style="width: 235px;">
                        <input-styled
                                name="contact-keyword"
                                :placeholder="'Ключевое слово'"
                                :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
                                :placeholderInput="'Ключевое слово'"
                                v-model="form.worker.keyword.value"
                                :auto-focus="true"
                                @focus="form.worker.keyword.error=false"
                                :is-error="form.worker.keyword.error">
                        </input-styled>
                    </div>
					<div style="width: 235px">
                        <input-styled
                                name="contact-keyword"
                                :placeholder="'Фамилия Имя Отчество'"
                                :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
                                :placeholderInput="'Фамилия Имя Отчество'"
                                v-model="form.worker.fio.value"
                                @focus="form.worker.fio.error=false"
                                :is-error="form.worker.fio.error">
                        </input-styled>
	                </div>
					<div style="width: 235px;">
	                    <input-styled
	                    name="worker-post"
	                    :placeholder="'Другие ключевые слова'"
                        :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
	                    :placeholderInput="'Другие ключевые слова'"
	                    v-model="form.worker.keywordOther.value"
	                    @focus="form.worker.keywordOther.error=false"
	                    :is-error="form.worker.keywordOther.error">
	                    </input-styled>
	                </div>

				</div>
                <div class="flex-row mb16">
                    <div style="width: 235px;">
                        <input-styled
                        name="worker-phone"
                        :placeholder="'Телефон'"
                        :placeholderInput="'Телефон'"
                        :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
                        v-model="form.worker.phone.value"
                        @focus="form.worker.phone.error=false"
                        :error-text="form.worker.phone.errorType === 'use' ? 'Этот номер уже существует':form.worker.phone.errorType === 'mobile' ? 'Только мобильные номера':''"
                        :is-error="form.worker.phone.error"
                        :mask="{mask:'+7(999)999-99-99',showMaskOnHover: false}">
                        </input-styled>
                    </div>

                    <div style="width: 235px">
                        <input-styled
                        name="worker-post"
                        :placeholder="'E-mail'"
                        :placeholderInput="'E-mail (необязательно)'"
                        :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
                        v-model="form.worker.email.value"
                        :error-text="form.worker.email.errorType === 'use' ? 'Этот email уже существует':form.worker.email.errorType === 'rule' && form.worker.email.value.length ? 'Некорректный email':''"
                        @focus="form.worker.email.error=false"
                        :is-error="form.worker.email.error">
                        </input-styled>
                    </div>
					<div style="width: 235px; height: 40px;">
                        <input-styled
                            v-if="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
                            name="worker-post"
                            :placeholder="'Группа'"
                            :disabled="true"
                            :placeholderInput="'Группа'"
                            v-model="form.selectGroup.value"
                            @focus="form.selectGroup.error=false"
                            :is-error="form.selectGroup.error">
                        </input-styled>
	                    <input-select
                            v-else
                            @change="form.selectGroup.error=false"
                            @open="form.selectGroup.error=false"
                            :tag="'div'"
                            :disabled="editContact.banned"
                            :isError="form.selectGroup.error"
                            v-model="form.selectGroup.value"
                            :options="selectOptionsDepartments"
                            :placeholder="'Группа'"
                            :list-style="{'max-height': 'none'}"></input-select>
	                </div>
                </div>
				<div class="full mb32">
					<textarea-field :class="'full'"
									v-model="form.comment.value"
									:error-text="''"
                                    :disabled="editContact.banned || editContact.is_owner && editContact.id !== currentUser.id"
									:is-error="form.comment.error"
									@focus="form.comment.error=false"
									placeholder="Информация"
									:add-style="{minHeight: 180 + 'px'}"></textarea-field>
				</div>
            </div>
            <div class="row-b mt32">
                <div class="row-b__col elem-pos-fix mr24">
                    <submit-btn class="" @click.native="send" :type="form.btnType">
                        <span class="i mr4" style="margin-top: -2px;" :class="{'i-ok7':form.btnType=='normal'}"></span>Сохранить
                    </submit-btn>
                </div>
            </div>
			<div class="add-worker__link remove" v-if="editContact && editContact.id && !editContact.banned && !editContact.is_owner">
                <a @click="openUserDismiss" href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-stop5"></span>
                    <span class="text">Больше не работаем</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
	import TextareaField from '@/components/forms/TextareaField.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputSelect from '@/components/forms/InputSelect.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';
    import InputMulti from '@/components/forms/InputMulti.vue';
    import {scrollTo} from "@/helpers/animate";
	import RightRadioSelect from '@/components/forms/RightRadioSelect.vue';

    export default {
        name: "AddContact",
        components: {
            InputStyled,
            SubmitBtn,
            InputSelect,
            InputMulti,
            InputSelectNew,
			RightRadioSelect,
			TextareaField,
        },
        props: {
            usersGroupedCurrentIndex: {
                default: false
            }
        },
        mounted(){
            if(this.editContact.fio){
                this.form.worker.fio.value = this.editContact.fio;
            }
            if(this.editContact.keyword){
                this.form.worker.keyword.value = this.editContact.keyword;
            }
            if(this.editContact.keywordOther){
                this.form.worker.keywordOther.value = this.editContact.keywordOther;
            }
            if(this.editContact.info){
                this.form.comment.value = this.editContact.info;
            }
            if(this.editContact.email){
                this.form.worker.email.value = this.editContact.email;
            }
            if(this.editContact.phone){
                this.form.worker.phone.value = this.editContact.phone;
            }
            if(this.editContact.group){
                this.form.selectGroup.value = this.getOptionsDepartmentsName(this.editContact.group);
            } else if(this.usersGroupedCurrentIndex && this.usersGroupedCurrentIndex !== 'dismiss') {
                this.form.selectGroup.value = this.getOptionsDepartmentsName(this.usersGroupedCurrentIndex);
            }
            if(this.editContact.id){
                for(let key in this.topSections){
                    let right = 0;
                    if(this.editContact.rights[this.topSections[key].id]){
                        if(this.editContact.rights[this.topSections[key].id] == 'R'){
                            right = 1;
                        }
                        if(this.editContact.rights[this.topSections[key].id] == 'W'){
                            right = 2;
                        }
                        if(this.editContact.rights[this.topSections[key].id] == 'C'){
                            right = 28;
                        }
                    }
                    this.$set(this.form.rights, this.topSections[key].id, right);
                }
            }
            else{
                for(let key in this.topSections){
                    this.$set(this.form.rights, this.topSections[key].id, 0);
                }
            }
        },
        data() {
            return {
                options: [
                  {name: '<span class=text-color-orange2>Читатель</span>', id: 1},
                  {name: '<span class=text-color-green>Редактор</span>', id: 2},
                  {name: '<span class=text-color-dark-blue>Модератор</span>', id: 28},
                  {name: '<span>Нет доступа</span>', id: 0}
                ],
                form:{
					comment: {
						value: '',
						error: false,
					},
                    selectGroup: {
                        value: '',
                        error: false,
                    },
                    selectAccess: {
                        id: 3,
                        error: false,
                    },
                    worker: {
                        keyword: {
                            value: '',
                            error: false,
                        },
                        fio: {
                            value: '',
                            error: false,
                        },
                        keywordOther: {
                            value: '',
                            error: false,
                        },
                        phone: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },
                        email: {
                            value: '',
                            error: false,
                            errorType: 'empty',
                        },

                    },
                    rights:{},
                    notifyWorker: {
                        value: false,
                        error: false,
                    },
                    btnType: 'normal',
                },
            }
        },
        methods: {
            blur(field){
                field.focus = false;
            },
            removeError: function(field) {
                field.error = false;
                field.focus = true;
            },
            close(){
                this.$store.commit('popups/close', {name: this.popups.addContact.name});
                this.$store.commit('contacts/setEditContact',[]);
                if(this.editContact.id){
                    this.$nextTick(()=>{
                        scrollTo('#user_'+this.this.editContact.id);
                    })
                }
            },
            send(closePopupAfterSave){
                if(this.editContact.banned){
                    this.close();
                } else {
                    let error = false;
                    this.form.worker.phone.errorType = 'empty';
                    this.form.worker.email.errorType = 'empty';

                    if(!this.form.selectGroup.value || this.form.selectGroup.value.length == 0){
                        if(this.form.selectGroup.error){
                            this.form.selectGroup.error = false;
                            setTimeout(() => {
                                this.form.selectGroup.error = true;
                            });
                        }else{
                            this.form.selectGroup.error = true;
                        }
                        error = true;
                    }
                    if(this.form.worker.keyword.value.length == 0){
                        this.repeatFieldError('keyword');
                        error = true;
                    }
                    if(this.form.worker.fio.value.length == 0){
                        this.repeatFieldError('fio');
                        error = true;
                    }
                    if(this.form.worker.phone.value.length == 0){
                        this.repeatFieldError('phone');
                        error = true;
                    } else {
                        let phone = this.form.worker.phone.value.replace(/[^\+0-9]/g, '');
                        if (phone.length < 12) {
                            error = true;
                            this.repeatFieldError('phone');
                        }
                    }
                    let rEmail = /^[\w\.\d-_]+@[\w\.\d-_]+\.\w{2,99}$/i;
                    if(this.form.worker.email.value.length > 0 && !rEmail.test(this.form.worker.email.value)){
                        this.repeatFieldError('email');
                        if(!rEmail.test(this.form.worker.email.value)){
                            this.form.worker.email.errorType = 'rule';
                        }
                        error = true;
                    }

                    if(!error){
                        this.form.btnType = 'load';
                        let params = {
                            id: this.editContact.id ? this.editContact.id : false,
                            form:{
                                group: this.selectedDepartmentId,
                                keyword: this.form.worker.keyword.value,
                                fio: this.form.worker.fio.value,
                                keywordOther: this.form.worker.keywordOther.value,
                                phone: this.form.worker.phone.value,
                                email: this.form.worker.email.value,
                                comment: this.form.comment.value,
                                type: 'saveContact',
                            }
                        };

                        this.$store.dispatch('contacts/add', params).then((result)=>{
                            this.form.btnType = 'normal';
                            this.$emit('change', this.selectedDepartmentId);
                            if(result.status == 'error'){
                                for(let e in result.statusErrors) {
                                    if(result.statusErrors[e] == 'phoneIsUsed'){
                                        this.repeatFieldError('phone');
                                        this.form.worker.phone.errorType = 'use';
                                    }
                                    if(result.statusErrors[e] == 'emailIsUsed'){
                                        this.repeatFieldError('email');
                                        this.form.worker.email.errorType = 'use';
                                    }
                                }
                            } else {
                                this.close();
                            }
                        });
                    }
                }

            },
			openUserDismiss(){
                if(this.editContact.id) {
                    this.$store.dispatch('contacts/add', {
                        id: this.editContact.id,
                        form:{
                            group: this.selectedDepartmentId,
                            keyword: this.form.worker.keyword.value,
                            fio: this.form.worker.fio.value,
                            keywordOther: this.form.worker.keywordOther.value,
                            phone: this.form.worker.phone.value,
                            email: this.form.worker.email.value,
                            comment: this.form.comment.value,
                            type: 'saveContact',
                        }
                    });
                    this.$store.commit('popups/close', {name: this.popups.addContact.name});
                    this.$store.commit('popups/open', {name: this.popups.dismissContact.name});
                }
            },
            getOptionsDepartmentsName(id){
                let result;
                this.contactsGrouped.forEach(function(item, i, arr) {
                    if(item.id == id){
                        result = item.name;
                        return false;
                    }
                });

                return result;
            },
            repeatFieldError(field){
                if(this.form.worker[field].error){
                    this.form.worker[field].error = false;
                    setTimeout(() => {
                        this.form.worker[field].error = true;
                    });
                }else{
                    this.form.worker[field].error = true;
                }
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                contactsGrouped: state => state.contacts.contacts,
                topSections: state => state.rules.topSectionsStaff,
                editContact: state => state.contacts.editContact,
                currentUser: state => state.users.user,
            }),
            admins(){
                let admins = [];
                for(let g in this.contactsGrouped){
                    for(let u in this.contactsGrouped[g].users){
                        if(this.contactsGrouped[g].users[u].is_owner && this.contactsGrouped[g].users[u].name != 'Админ Тестовый'){
                            admins.push(this.contactsGrouped[g].users[u])
                        }
                    }
                }
                return admins;
            },
            selectOptionsDepartments(){
                let result = [];
                this.contactsGrouped.forEach(function(item, i, arr) {
                    result.push(item.name);
                });
                return result;
            },
            selectedDepartmentId(){
                let this_ = this, result;

                this.contactsGrouped.forEach(function(item, i, arr) {
                    if(item.name == this_.form.selectGroup.value){
                        result = item.id;
                        return false;
                    }
                });
                return result;
            },
        },
    }
</script>

<style scoped>

</style>
